"use client";

import { motion, useReducedMotion } from "framer-motion";

const testimonials = [
  {
    source: "Dutch learner",
    context: "Learner feedback",
    content: "It got me over the first hump to actually speak Dutch.",
  },
  {
    source: "YouTube reviewer",
    context: "Product review",
    content: "The simplicity is amazing. It's like working with a tutor.",
  },
  {
    source: "Mandarin learner",
    context: "Reddit feedback",
    content: "Excellent resource for intermediate learners.",
  },
];

export function LandingTestimonials() {
  const shouldReduceMotion = useReducedMotion();

  return (
    <section className="bg-white py-16 md:py-24" aria-labelledby="learner-stories-title">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={shouldReduceMotion ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          className="mb-10 max-w-3xl md:mb-14"
        >
          <h2
            id="learner-stories-title"
            className="text-3xl font-bold tracking-[-0.035em] text-[#1C1C1E] md:text-5xl"
          >
            The first win is saying it out loud
          </h2>
          <p className="mt-4 max-w-[58ch] text-lg leading-8 text-gray-600">
            Learners use ChickyTutor to practise before the conversation counts.
          </p>
        </motion.div>

        <div className="grid gap-5 md:grid-cols-[1.25fr_0.75fr]">
          <motion.blockquote
            initial={shouldReduceMotion ? false : { opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            className="flex min-h-[330px] flex-col justify-between rounded-2xl bg-[#1C1C1E] p-7 text-white md:p-10"
          >
            <p className="max-w-[20ch] text-2xl font-bold leading-snug tracking-[-0.025em] md:text-4xl">
              “{testimonials[0].content}”
            </p>
            <footer className="mt-8">
              <cite className="not-italic font-bold">{testimonials[0].source}</cite>
              <p className="mt-1 text-sm text-gray-400">{testimonials[0].context}</p>
            </footer>
          </motion.blockquote>

          <div className="grid gap-5">
            {testimonials.slice(1).map((testimonial, index) => (
              <motion.blockquote
                key={testimonial.source}
                initial={shouldReduceMotion ? false : { opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.35 }}
                transition={{ delay: shouldReduceMotion ? 0 : index * 0.08 }}
                className="flex flex-col justify-between rounded-2xl border border-gray-200 bg-[#F5F5F0] p-6"
              >
                <p className="text-lg font-medium leading-7 text-[#2C2C2E]">
                  “{testimonial.content}”
                </p>
                <footer className="mt-6">
                  <cite className="not-italic font-bold text-[#1C1C1E]">{testimonial.source}</cite>
                  <p className="mt-1 text-sm text-gray-500">{testimonial.context}</p>
                </footer>
              </motion.blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
